import { useContext, useState } from 'react';
import { AccountContext } from '../AccountContext';
import { useAsyncEffect } from '../../../hooks/UseAsyncEffect';
import { toCurrency, toFormattedDate } from '../../../utilities/FormatHelpers';



function showBreakDown(projectedPayment: any): boolean {
    if (projectedPayment.paymentTransactionIds.length > 0) {
        return true;
    }

    if (projectedPayment.paymentReversalTransactionIds.length > 0) {
        return true;
    }

    if (projectedPayment.creditAdjustedBalance?.value) {
        return true;
    }

    return false;
}

function TransactionsList({ transactionIds }: { transactionIds: [] }) {
    return (
        <div className="ui list">
            {transactionIds.map(id => (<div className="item" key={id}>{id}</div>))}
        </div>
    );
}

function Breakdown({ projectedPayment }: { projectedPayment: any }) {
    return (
        <table className="ui compact table">
            <thead>
                <tr>
                    <th>Payment Transactions</th>
                    <th>Payment Reversal Transactions</th>
                    <th>Adjusted Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        {<TransactionsList transactionIds={projectedPayment.paymentTransactionIds} />}
                    </td>
                    <td>
                        {<TransactionsList transactionIds={projectedPayment.paymentReversalTransactionIds} />}
                    </td>
                    <td>{toCurrency(projectedPayment.creditAdjustedBalance?.value)}</td>
                </tr>
            </tbody>
        </table>
    );
}

export function ProjectedPayment(props: { lastUpdatedDate }) {
    const { accountId, regularPaymentService, setError } = useContext(AccountContext);
    const [loading, setLoading] = useState(true as boolean);
    const [projectedPayment, setProjectedPayment] = useState(undefined as any);
    const [expand, setExpand] = useState(false as boolean);

    useAsyncEffect(async () => {
        try {
            setLoading(true);
            const response = await regularPaymentService.getProjectedPayments(accountId);
            setProjectedPayment(response);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError({ source: 'Get Projected Payments', ...error });
        }
    }, [accountId, props.lastUpdatedDate]);

    return (
        <>
            <h2>Projected Payments</h2>
            {loading && <div className="ui active centered inline loader" />}

            {!loading && projectedPayment == null && <p>No projected payments</p>}

            {!loading && projectedPayment && (
                <table className="ui compact table" style={{ marginBottom: '20px' }}>
                    <thead>
                        <tr>
                            <th>SortCode</th>
                            <th>Account Number</th>
                            <th>Adjustment Type</th>
                            <th>Adjustment Days</th>
                            <th>Collection Date</th>
                            <th>Due Date</th>
                            <th>Payment Type</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{projectedPayment.sortCode}</td>
                            <td>{projectedPayment.bankAccountNumber}</td>
                            <td>{projectedPayment.collectionDateAdjustment.type}</td>
                            <td>{projectedPayment.collectionDateAdjustment.days}</td>
                            <td>{toFormattedDate(projectedPayment.collectionDate)}</td>
                            <td>{toFormattedDate(projectedPayment.statementDueDate)}</td>
                            <td>{projectedPayment.paymentType}</td>
                            <td>{toCurrency(projectedPayment.amount?.value)}</td>
                            <td>
                                {showBreakDown(projectedPayment) && (
                                    <button className={`ui button`} onClick={() => setExpand(!expand)} type="button" >
                                        {expand ? "Collaspe" : "Expand"}
                                    </button>)
                                }
                            </td>
                        </tr>
                        {expand && (
                            <tr>
                                <td colSpan={8}>{<Breakdown projectedPayment={projectedPayment} />}</td>
                            </tr>)
                        }
                    </tbody>
                </table>
            )}
        </>
    );
}
